(ns frontend.view.modals.change-pipeline.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.change-pipeline.events :as events]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(defonce modal-key :change-pipeline-modal)

(defn render-pipeline-selection
  [original-pipeline-id state]
  (let [original-pipeline (get @session/entities original-pipeline-id)
        pipeline-options (->> @session/all-pipelines
                              (remove (fn [p]
                                        (or (not (session/access-to-pipeline @session/account p))
                                            (= (:db/id p) original-pipeline-id)
                                            (not= (:pipeline/entity-type p)
                                                  (:pipeline/entity-type original-pipeline)))))
                              (map (fn [p]
                                     {:value (:db/id p)
                                      :label (entity/display-string p)})))]
    [:div.zap-select.zap-form__light-grey__green__sand.form-group
     [:label.zap-label.control-label (loc/tr :select-target-asset-type) [:span.mandatory "*"]]
     [data-input/view
      {:editor-type :editor.type/select
       :data-type   :data.type/ref-single
       :value       (:selected-pipeline-id @state)
       :options     pipeline-options
       :on-change   (fn [new-value & _]
                      (when (not= new-value (:selected-pipeline-id @state))
                        (swap! state dissoc :selected-stage-id)
                        (swap! state assoc :selected-pipeline-id new-value)))}]]))

(defn render-stage-selection
  [state]
  (let [new-pipeline-id (:selected-pipeline-id @state)
        new-pipeline (get @session/entities new-pipeline-id)
        [stage-entity-type stage-pipeline-attribute]
        (case (:pipeline/entity-type new-pipeline)
          :entity.type/oppo
          [:entity.type/stage :stage/pipeline]
          :entity.type/fundraising-opportunity
          [:entity.type/opportunity-stage :opportunity-stage/pipeline]
          :entity.type/sales-opportunity
          [:entity.type/sales-opportunity-stage :sales-opportunity-stage/pipeline]
          :entity.type/exit-opportunity
          [:entity.type/exit-opportunity-stage :exit-opportunity-stage/pipeline])
        stages-in-new-pipeline-options (->> (session/get-entities stage-entity-type)
                                            (filter (fn [s]
                                                      (let [stage-pipeline-id
                                                            (get s stage-pipeline-attribute)]
                                                        (= new-pipeline-id stage-pipeline-id))))
                                            (sort-by :common/ord)
                                            (map (fn [s]
                                                   {:value (:db/id s)
                                                    :label (entity/display-string s)})))]
    [:div.zap-select.zap-form__light-grey__green__sand.form-group
     [:label.zap-label.control-label (loc/tr stage-entity-type) [:span.mandatory "*"]]
     [data-input/view
      {:editor-type :editor.type/select
       :data-type   :data.type/ref-single
       :value       (:selected-stage-id @state)
       :options     stages-in-new-pipeline-options
       :on-change   (fn [new-value & _]
                      (swap! state assoc :selected-stage-id new-value))}]]))

(defn view
  [{:keys [props state]}]
  (let [{:keys [selected-pipeline-id]} props]
    (swap! state assoc :selected-pipeline-id selected-pipeline-id)
    (fn [{:keys [shown? close-modal! props state topmost?]}]
      (let [{:keys [ofs-opportunity original-pipeline-id on-close!]} props
            on-close! (fn []
                        (when (fn? on-close!)
                          (on-close!))
                        (close-modal!))]

        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/danger
          :close-button? true}
         (if-let [selected-pipeline-id (:selected-pipeline-id @state)]
           (loc/tr :select-stage-in-another-pipeline
                   [(->> (get @session/entities selected-pipeline-id)
                         (entity/display-string))])
           (loc/tr :move-to-pipeline))
         (if-not (:selected-pipeline-id @state)
           (render-pipeline-selection original-pipeline-id state)
           (render-stage-selection state))
         [:<>
          [:div
           {:class "flex gap-3"}
           (when (:target-asset-type @state)
             [button/secondary-hollow
              {:color    ::c/secondary
               :on-click #(swap! state dissoc :target-asset-type)}
              (loc/tr :back)])
           [button/secondary-hollow
            {:on-click on-close!}
            (loc/tr :cancel)]]
          [:div
           {:class "flex gap-3 justify-end"}
           [button/primary-solid
            {:disabled? (not (events/form-ready? state))
             :on-click  (fn [_e]
                          ;; Route through the entry-criteria flow so a
                          ;; pipeline change is just a stage move with an
                          ;; extra `:target-pipeline`. The entry-criteria
                          ;; modal (when needed) opens on top and submits
                          ;; the actual write.
                          ;;
                          ;; Order matters: `close-modal!` tears down this
                          ;; modal's `state` cursor synchronously, so the
                          ;; reads of `:selected-stage-id` /
                          ;; `:selected-pipeline-id` would come back nil if
                          ;; the close ran first. Fire the move now, defer
                          ;; the close past this tick so the criteria modal
                          ;; lands on the stack before this one comes off.
                          (f-entity/attempt-move-to-stage!
                           {:opportunity ofs-opportunity
                            :target-stage (:selected-stage-id @state)
                            :target-pipeline (:selected-pipeline-id @state)
                            :on-success! (fn [_]
                                           (when (fn? on-close!)
                                             (on-close!)))
                            :on-error! (fn [err]
                                         (logging/error "Failed to change pipeline " err))
                            :on-cancel! (fn []
                                          ;; User backed out of the criteria
                                          ;; / no-target step; treat like
                                          ;; closing this modal.
                                          (when (fn? on-close!)
                                            (on-close!)))})
                          (js/setTimeout close-modal! 100))}
            (loc/tr :save)]]]]))))
